import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiGetSocialNetworkById, apiEditSocialNetwork } from 'services/SocialNetworkService'

export const getSocialNetwork = createAsyncThunk('SocialNetworkEdit/data/getSocialNetworks', async (data) => {
    const response = await apiGetSocialNetworkById(data)
    return response.data
})

export const updateSocialNetwork = async (data) => {
    const response = await apiEditSocialNetwork(data)   
    return response.data
}


const dataSlice = createSlice({
    name: 'SocialNetworkEdit/data',
    initialState: {
        loading: false,
        productData: [],
        
    },
    reducers: {
    },
    extraReducers: {
        [getSocialNetwork.fulfilled]: (state, action) => {
            state.productData = action.payload
            state.loading = false
        },
        [getSocialNetwork.pending]: (state) => {
            state.loading = true
        },
    }
})

export default dataSlice.reducer
